export const providerRatingMap: Record<string, { rating: number, reviews: number }> = {
  swisscom: {
    rating: 5,
    reviews: 49,
  },
  sunrise: {
    rating: 4,
    reviews: 63,
  },
  salt: {
    rating: 4,
    reviews: 72,
  },
  wingo: {
    rating: 5,
    reviews: 76,
  },
  yallo: {
    rating: 4,
    reviews: 49,
  },
  talktalk: {
    rating: 4,
    reviews: 17,
  },
  'migros-mobile': {
    rating: 4,
    reviews: 6,
  },
  quickline: {
    rating: 5,
    reviews: 3,
  },

}

export const providerWebsiteMap: Record<string, string> = {
  swisscom: 'https://www.swisscom.ch',
  sunrise: 'https://www.sunrise.ch',
  salt: 'https://www.salt.ch',
  wingo: 'https://www.wingo.ch',
  yallo: 'https://www.yallo.ch',
  talktalk: 'https://www.talktalk.ch',
  'migros-mobile': 'https://mobile.migros.ch',
  quickline: 'https://www.quickline.ch',
  mtel: 'https://mtel.ch',
  spusu: 'https://www.spusu.ch',
  teleboy: 'https://www.teleboy.ch',
  init7: 'https://www.init7.net',
}
